import React, { useEffect, useState } from 'react';
import { TicketApi } from '../../redux/api/TicketApi';
import TicketCard from './TicketCard';
import { ITicketProps } from '../../types/Ticket/ITicket';
import { RevUserContext, RevUserContextType } from '../../context/UserContext';
import { PageChangeEvent, Pager } from '@progress/kendo-react-data-tools';
import { ListView } from '@progress/kendo-react-listview';
import { CompositeFilterDescriptor, filterBy, FilterDescriptor } from '@progress/kendo-data-query';
import { Button } from '@progress/kendo-react-buttons';
import * as svg from '@progress/kendo-svg-icons';
import { Link } from 'react-router-dom';
import { PartialSpinny } from '../Nav/Spinny';
const TicketCardList: React.FC = () => {
    const userProfile = React.useContext<RevUserContextType>(RevUserContext).profile;
    const { data: tickets, isLoading } = TicketApi.useGetMyHomeTicketsQuery(null);
    const { setHeaderText, profile } = React.useContext<RevUserContextType>(RevUserContext)
    const [filter, setFilter] = useState('');
    const [data, setData] = React.useState(tickets?.slice());

    // useEffect(() => {
    //     setPageIsMobile(isMobile)
    // }, [window.innerWidth, isMobile]);

    const [page, setPage] = React.useState({
        skip: 0,
        take: 20
    });

    const handlePageChange = (e: PageChangeEvent) => {
        setPage({
            skip: e.skip,
            take: e.take
        });
    }

    const { skip, take } = page;
    const renderItem = props => {
        let ticket = props.dataItem;
        return (<TicketCard {...ticket as ITicketProps} />);
    }
    useEffect(() => {
        if (tickets) {
            setData(filterBy(tickets?.slice().sort((a, b) => b.ID - a.ID), {
                filters: [
                    { field: 'ID', operator: 'contains', value: filter || '' },
                    { field: 'Company_Name', operator: 'contains', value: filter || '' },
                    { field: 'Contact_Name', operator: 'contains', value: filter || '' },
                    { field: 'Project_Name', operator: 'contains', value: filter || '' },
                    { field: 'Call_Desc', operator: 'contains', value: filter || '' },
                ], logic: 'or'
            } as CompositeFilterDescriptor));

            //Reset the page on filter change
            if (filter) {
                setPage((p) => {
                    return {
                        skip: 0,
                        take: p.take
                    }
                });
            }
        }
    }, [filter, tickets]);

    const internalUser = !userProfile?.Features.External_Interface;

    return (
        <>
            {isLoading && <PartialSpinny />}
            <div className='row2 home-page-header'>
                <div className={internalUser ? 'col-11' : 'col'}>
                    <input type="text" value={filter} className='form-control filter-control' placeholder='Filter' onChange={(e) => setFilter(e.target.value)} />
                </div>
                {internalUser && <div className='col-1 text-right'>
                    <Link to='/monitor'> <Button size='medium' svgIcon={svg.gearIcon}></Button></Link>
                </div>}
            </div>
            {data && <Pager
                responsive={false}
                className='home-pager'
                skip={skip}
                take={take}
                onPageChange={handlePageChange}
                total={data?.length}
                buttonCount={5}
            />}
            <div className=''>
                <ListView
                    data={data?.slice(skip, skip + take)}
                    item={renderItem}
                    style={{ width: "100%" }}
                />
            </div>
        </>
    );
};

export default TicketCardList;